/*
 * @Description:
 * @Date: 2022-09-09 12:30:55
 */
import FaceAuthAgreement from './views/face-auth-agreement.vue';
import FaceAuthResult from './views/face-auth-result.vue';
import { route } from './router';

const name = 'face-auth';
export { name, route, FaceAuthAgreement, FaceAuthResult };
